'use client';

import type { InventoryResource, Snapshot } from '@repo/api-gw-sdk';

import { SelectTargetWorkspaceStep } from './steps/selectTargetWorkspace';
import { WorkspaceRestoreConfiguration } from './steps/workspaceRestoreConfiguration';

import type { Step } from '../wizard/Step';
import { Wizard } from '../wizard/Wizard';

export interface GoogleWorkspaceRestoreState {
  resource: InventoryResource;
  snapshot: Snapshot;
  files: { path: string; isDirectory: boolean }[];
  targetWorkspace?: InventoryResource;
  restoreMode: 'overwrite' | 'rename';
  newName: string;
}

const restoreGoogleWorkspaceFlow: Step<GoogleWorkspaceRestoreState>[] = [
  {
    id: 'select_target_workspace',
    Component: SelectTargetWorkspaceStep,
    next: [
      {
        id: 'workspace_restore_configuration',
        Component: WorkspaceRestoreConfiguration,
      },
    ],
  },
];

interface Props {
  path: string;
  snapshot: Snapshot;
  resource: InventoryResource;
  isDirectory: boolean;
  onClose: () => void;
  /** Called after a successful restore, before the panel closes */
  onComplete?: () => void;
}

export const RestoreGoogleWorkspaceWizard = (props: Props) => {
  const files = [{ path: props.path, isDirectory: props.isDirectory }];

  return (
    <Wizard<GoogleWorkspaceRestoreState>
      key={props.path}
      onFinish={async () => {
        props.onComplete?.();
        return true;
      }}
      onAbort={props.onClose}
      flow={restoreGoogleWorkspaceFlow}
      initialState={{
        files,
        resource: props.resource,
        snapshot: props.snapshot,
        restoreMode: 'overwrite',
        newName: '',
      }}
      title='Restore to Google Workspace'
      hideBackArrow
      stepperLabels={['Target Workspace', 'Restore Configuration']}
    />
  );
};
